import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ScrollService {
  scrollContainers: any;

  constructor() {
    this.scrollContainers = {};
  }

  addContainer(name: string, element: any) {
    if (this.scrollContainers[name]) {
      this.scrollContainers[name].parent = element;
      return this.scrollContainers[name].scrollToStream;
    } else {
      const scrollToSource = new Subject<any>();
      const scrollToStream = scrollToSource.asObservable();

      this.scrollContainers[name] = {
        parent: element,
        children: [],
        scrollToSource: scrollToSource,
        scrollToStream: scrollToStream,
      };
      return scrollToStream;
    }
  }

  // add ref to scroll container
  addChild(containerName: string, element: any, id: string) {
    if (!this.scrollContainers[containerName]) {
      this.addContainer(containerName, undefined);
    }

    if (this.containsId(containerName, id)) {
      this.findChildById(containerName, id).element = element;
    } else {
      const highlightSource = new Subject<any>();
      const highlightStream = highlightSource.asObservable();
      this.scrollContainers[containerName].children.push({
        source: highlightSource,
        stream: highlightStream,
        element: element,
        id: id,
      });
    }
  }

  // regiser the anchor and get the child highlight subscription
  addAnchor(containerName: string, childId: string) {
    if (!this.scrollContainers[containerName]) {
      this.addContainer(containerName, undefined);
    }

    if (!this.containsId(containerName, childId)) {
      this.addChild(containerName, undefined, childId);
    }

    return this.findChildById(containerName, childId).stream;
  }

  private findChildById(containerName: string, childId: string) {
    for (const child of this.scrollContainers[containerName].children) {
      if (child.id === childId) {
        return child;
      }
    }
    return null;
  }

  private containsId(containerName: string, childId: string) {
    for (const child of this.scrollContainers[containerName].children) {
      if (child.id === childId) {
        return true;
      }
    }
    return false;
  }

  // called when the parent element scrolls, parent provides current scrollTop
  onScroll(containerName: string) {
    const parent = this.scrollContainers[containerName].parent;
    const children = this.scrollContainers[containerName].children;
    let minChild = children[0];
    for (let i = 1; i < children.length; i++) {
      if (children[i].element) {
        const childTop = children[i].element.getBoundingClientRect().top;
        const position = childTop - parent.getBoundingClientRect().top;
        if (position < 10 && childTop > minChild.element.getBoundingClientRect().top) {
          minChild = children[i];
        }
      }
    }

    for (const child of children) {
      if (child === minChild) {
        child.source.next(true);
      } else {
        child.source.next(false);
      }
    }
  }

  // called by anchor
  scrollTo(containerName: string, id: string) {
    this.scrollContainers[containerName].scrollToSource.next(
      this.findChildById(containerName, id).element,
    );
  }
}
